import React from 'react';
import { IconProps } from './types';

export const AngleIcon = ({ className, title }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.105"
      height="10.263"
      viewBox="0 0 17.105 10.263"
      className={className}
    >
      <title>{title}</title>
      <g
        id="Arrow_Small_Dark_Blue"
        data-name="Arrow Small Dark Blue"
        transform="translate(17.105 10.263) rotate(180)"
      >
        <path
          id="Mask"
          d="M1.806,0,0,1.78l8.556,8.483,8.549-8.484L15.3,0,8.555,6.692Z"
        />
      </g>
    </svg>
  );
};
